import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5046d584"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "navbar-tour"
}
const _hoisted_2 = {
  slot: "dialog-header",
  class: "navbar-tour_image-wrapper"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { slot: "dialog-body" }
const _hoisted_5 = { class: "navbar-tour_subheader" }
const _hoisted_6 = { class: "navbar-tour_title" }
const _hoisted_7 = { class: "navbar-tour_description" }

import {onMounted, ref, onUpdated} from 'vue';
    import {NavBarDisplayMode, TourCard, useDisplayMode, useExpandedTabs} from '@/logged/features';
    import {useOnboardingExistingUser} from '@/logged/features/onboarding-existing-user';
    import {useUser} from '@/logged/features/user';
    import {storeToRefs} from 'pinia';
    import {useDisplayMobile, usePrefetchImages} from '@/logged/common/composables';
    import {NewUserOnboardingModal} from '../../onboarding-new-user';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'ExistingUserOnboarding',
  setup(__props) {

    const onboardingExistingUserStore = useOnboardingExistingUser();
    const {isDisplayMobile} = useDisplayMobile();

    const {activeTours, displayedPresentationGif, filteredIllustrationsByLanguage} = storeToRefs(onboardingExistingUserStore);

    const displayModeStore = useDisplayMode();
    const navbarTourDialog = ref<HTMLJoyDialogElement | null>(null);
    const takeTourButton = ref<HTMLJoyDialogElement | null>(null);
    const isNotNowCTA = ref<boolean>(false);
    const expandedTabsStore = useExpandedTabs();
    const userStore = useUser();

    const {loaded} = usePrefetchImages([displayedPresentationGif.value]);

    usePrefetchImages(filteredIllustrationsByLanguage);

    const scrollToElement = () => {
        const button = takeTourButton.value;
        if (button) {
            setTimeout(() => {
                button.scrollIntoView({behavior: 'smooth'});
            }, 100);
        }
    };

    onUpdated(() => {
        scrollToElement();
    });

    onMounted(() => {
        displayModeStore.setNavBarDisplayMode(NavBarDisplayMode.FULL);
    });

    async function handleCancel() {
        userStore.acknowledgeOnboarding();
    }

    function notNow() {
        isNotNowCTA.value = true;
        takeATour();
    }

    async function takeATour() {
        expandedTabsStore.expandTab(activeTours.value[0].navTabId);
        await navbarTourDialog.value?.closeDialog({fireCancelEvent: false});

        if (isNotNowCTA.value) {
            return;
        }

        userStore.acknowledgeOnboarding(false);
    }

return (_ctx: any,_cache: any) => {
  const _component_joy_button = _resolveComponent("joy-button")!
  const _component_joy_product_tour_trigger = _resolveComponent("joy-product-tour-trigger")!
  const _component_joy_dialog = _resolveComponent("joy-dialog")!

  return (_unref(isDisplayMobile))
    ? (_openBlock(), _createBlock(_unref(NewUserOnboardingModal), {
        key: 0,
        mode: "existing"
      }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
          (_unref(loaded))
            ? (_openBlock(), _createBlock(_component_joy_dialog, {
                key: 0,
                ref_key: "navbarTourDialog",
                ref: navbarTourDialog,
                "data-testid": "navbar-tour-dialog",
                open: "",
                onJoyCancelDialog: handleCancel
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("img", { src: _unref(displayedPresentationGif) }, null, 8, _hoisted_3)
                  ]),
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$msg('navbar.tour.welcome.dialog.subheader')), 1),
                    _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$msg('navbar.tour.welcome.dialog.title')), 1),
                    _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(userStore).hasSelectedFreelanceIdentity
                                ? _ctx.$msg('freelancer.navbar.tour.welcome.dialog.description')
                                : _ctx.$msg('navbar.tour.welcome.dialog.description')), 1)
                  ]),
                  (_unref(userStore).hasSelectedFreelanceIdentity)
                    ? (_openBlock(), _createBlock(_component_joy_product_tour_trigger, {
                        key: 0,
                        slot: "dialog-confirm"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_joy_button, {
                            size: "small",
                            variant: "ghost",
                            onClick: notNow
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$msg('freelancer.navbar.tour.welcome.not.now')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_joy_product_tour_trigger, {
                    slot: "dialog-confirm",
                    ref_key: "takeTourButton",
                    ref: takeTourButton,
                    "product-tour": `navbarTour${_unref(activeTours)?.[0].navTabId}`,
                    target: `[data-testid='${_unref(activeTours)?.[0].navTabId}']`
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_joy_button, {
                        size: "small",
                        variant: "main",
                        onClick: takeATour
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$msg('navbar.tour.welcome.dialog.cta.take.tour')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["product-tour", "target"])
                ]),
                _: 1
              }, 512))
            : _createCommentVNode("", true)
        ])),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(activeTours), (tour, index) => {
          return (_openBlock(), _createBlock(_unref(TourCard), {
            key: tour.navTabId,
            tour: tour,
            "tour-index": index
          }, null, 8, ["tour", "tour-index"]))
        }), 128))
      ]))
}
}

})